import Text from 'Components/Atoms/Text/Text';
import Title from 'Components/Atoms/Title/Title';
import TitleGroup from 'Components/Molecules/TitleGroup/TitleGroup';
import { Helmet } from 'react-helmet-async';
import { ROUTES } from 'Services/Route/Route.types';
import PageTemplate from '../Page/PageTemplate';
import styles from './SettingsTemplate.module.sass';

const SettingsTemplate = ({
    children,
    breadcrumbs, description
}: any) => {
    return <PageTemplate>
        <Helmet>
            <title>{ ROUTES.SETTINGS.title }</title>
        </Helmet>
        <div className={styles['settingstemplate']}>
            <div className={styles['settingstemplate__header']}>
                <TitleGroup>
                    { breadcrumbs || <Title size='small' weight='semibold'>Instellingen</Title> }
                    <Text color='secondary'>{ description || "Selecteer een instellingscategorie"}</Text>
                </TitleGroup>
            </div>
            <div className={styles['settingstemplate__content']}>
                { children }
            </div>
        </div>
    </PageTemplate> 
}

export default SettingsTemplate;